<template>
  <main-drawer :title="isEdit ? $tc('settings.edit_category') : $tc('settings.create_category')" @close="$emit('close')">
    <main-input v-model="form.name" :label="$tc('form.name')" :validator="$v.form.name" />

    <div class="form-group">
      <label>Za takmicare godina: <span class="required">*</span></label>
      <el-row :gutter="10">
        <el-col :span="12">
          <main-input v-model="form.ageFrom" type="number" :validator="$v.form.ageFrom" />
        </el-col>
        <el-col :span="12">
          <main-input v-model="form.ageTo" type="number" :validator="$v.form.ageTo" />
        </el-col>
      </el-row>
    </div>

    <main-checkbox v-model="form.noPay" :label="$tc('settings.category_not_chargeable')" />

    <template v-slot:footer>
      <div class="flex-buttons">
        <el-button @click="$emit('close')">{{ $tc('general.cancel') }}</el-button>
        <el-button type="primary" @click="save()">{{ isEdit ? $tc('general.edit') : $tc('general.create')}}</el-button>
      </div>
    </template>
  </main-drawer>
</template>

<script>
import errorHandler from '@/common/errorHandler.js'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    category: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      form: {
        name: null,
        noPay: false,
        ageFrom: null,
        ageTo: null
      }
    }
  },

  computed: {
    isEdit () {
      return !!this.category
    }
  },

  created () {
    if (this.isEdit) {
      this.form = {
        name: this.category.name,
        noPay: this.category.noPay,
        ageFrom: this.category.ageFrom || null,
        ageTo: this.category.ageTo || null
      }
    }
  },

  watch: {
    'form.ageFrom' () {
      if (this.$v.form.ageTo) {
        this.$v.form.ageTo.$touch()
      }
    },
    'form.ageTo' () {
      if (this.$v.form.ageFrom) {
        this.$v.form.ageFrom.$touch()
      }
    }
  },

  methods: {
    async save () {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) return

      this.loading = true
      try {
        if (this.isEdit) {
          await this.$store.dispatch('categories/update', {
            id: this.category.id,
            payload: this.form
          })
        } else {
          await this.$store.dispatch('categories/create', this.form)
        }
        this.$message.success(this.isEdit ? this.$tc('messages.success_updated_category') : this.$tc('messages.success_created_category'))

        this.$emit(this.isEdit ? 'add' : 'edit')
      } catch (error) {
        console.error(error)
        errorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  validations () {
    const ageToGreaterThanAgeFrom = (value) => {
      if ((!value && value !== 0) || this.form.ageFrom === null) return true
      return Number(value) >= Number(this.form.ageFrom)
    }

    return {
      form: {
        name: { required },
        ageFrom: { required },
        ageTo: { ageToGreaterThanAgeFrom }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group {
  display: block;
  margin: 5px 0;
  box-sizing: border-box;

  label {
    display: block;
    font-size: 16px;
    margin-bottom: 5px;
  }

  .required {
    color: #d23131;
  }
}

.form-group + .form-group {
  margin-top: 15px;
}
</style>
